module.exports = __webpack_public_path__ + "static/media/image (35).25eb0580.jpg";